export default {
    name: "Bitcoin II",
    coin: "BC2",
    scheme: "SOLO",
    account: 'bc1q30kj2jfz9f35xde455343ck0rq3wpxlp5js0la',
    url: '',
    explorer_url: 'https://bitcoinii.ddns.net',
    coingecko: '',
    explorer: {
        address: 'https://bitcoinii.ddns.net/explorer/address/',
        height: 'https://bitcoinii.ddns.net/explorer/block-height/',
        hash: 'https://bitcoinii.ddns.net/explorer/block/',
        tx: 'https://bitcoinii.ddns.net/explorer/tx/',
    },
    ports: [
        {
            info: 'LOW',
            vardiff: true,
            host: 'molepool.com',
            port: 4081,
            diff: 262144,
        },
        {
            info: 'MID',
            vardiff: false,
            host: 'molepool.com',
            port: 4082,
            diff: 1048576,
        },
    ]
};